import React, { useEffect, useState } from "react";
import "../../styles/settings.css";
import toast from "react-hot-toast";
import SettingServices from "../../services/SettingServices";
import Loader from "../../components/Loader";
import NoData from "../../components/NoData";
import AppLogo from "../../components/AppLogo";

export default function Settings() {
  const settingApi = new SettingServices();

  const [yantra, setYantra] = useState(0);
  const [winning, setWinning] = useState(0);
  const [difference, setDifference] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loginNotes, setLoginNotes] = useState("");
  const [loginNotesLoading, setLoginNotesLoading] = useState(false);
  const [homeNotes, setHomeNotes] = useState("");
  const [homeNotesLoading, setHomeNotesLoading] = useState(false);
  const [liveSessionNotesLoading, setLiveSessionNotesLoading] = useState(false);
  const [liveSessionNote1, setLiveSessionNote1] = useState("");
  const [liveSessionNote2, setLiveSessionNote2] = useState("");
  const [winningSlipNote, setWinningSlipNote] = useState("");
  const [winningSlipNoteLoading, setWinningSlipNoteLoading] = useState(false);
  const [mainTitle, setMainTitle] = useState("");
  const [subTitle, setSubTitle] = useState("");

  //
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [filter, setFilter] = useState(3);
  const [referenceTypeFilter, setReferenceTypeFilter] = useState("GLOBAL");
  const [pagination, setPagination] = useState({});

  const [games, setGames] = useState({
    "3min": false,
    "5min": false,
  });

  const toggleGame = (type) => {
    setGames({ ...games, [type]: !games[type] });
  };

  const handleSave = async () => {
    setLoading(true);
    const payload = {
      main_title: mainTitle,
      sub_title: subTitle,
      yantra_amount: yantra,
      winning_amount: winning,
      difference: difference,
      game_3min: games["3min"],
      game_5min: games["5min"],
    };

    settingApi
      .UpdateSettingData(payload)
      .then((response) => {
        if (response.isSuccess) {
          toast.dismiss();
          toast.success(response.message || "Settings updated successfully");
          try {
            window.dispatchEvent(
              new CustomEvent("app-brand-updated", {
                detail: { main_title: mainTitle, sub_title: subTitle },
              }),
            );
          } catch (_) {}
          getSettingData();
          getSettingHistory();
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error("Error updating settings:", error);
        toast.dismiss();
        toast.error("Failed to save settings");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSaveLoginNotes = async () => {
    setLoginNotesLoading(true);
    const payload = {
      login_notes: loginNotes,
    };
    settingApi
      .UpdateLoginNotes(payload)
      .then((response) => {
        if (response.isSuccess) {
          toast.success(response.message || "Login notes saved successfully");
          getSettingData();
          getSettingHistory();
        }
      })
      .catch((error) => {
        console.error("Error saving login notes:", error);
        toast.dismiss();
        toast.error("Failed to save login notes");
      })
      .finally(() => {
        setLoginNotesLoading(false);
      });
  };
  const handleSaveHomeNotes = async () => {
    setHomeNotesLoading(true);
    const payload = {
      home_notes: homeNotes,
    };
    settingApi
      .UpdateHomeNotes(payload)
      .then((response) => {
        if (response.isSuccess) {
          toast.success(response.message || "Home notes saved successfully");
          getSettingData();
          getSettingHistory();
        }
      })
      .catch((error) => {
        console.error("Error saving home notes:", error);
        toast.dismiss();
        toast.error("Failed to save home notes");
      })
      .finally(() => {
        setHomeNotesLoading(false);
      });
  };

  const handleSaveLiveSessionNotes = async (note) => {
    setLiveSessionNotesLoading(true);
    const payload = {
      note: note,
      live_session_notes:
        note === "note1" ? liveSessionNote1 : liveSessionNote2,
    };
    settingApi
      .UpdateLiveSessionNotes(payload)
      .then((response) => {
        if (response.isSuccess) {
          toast.success(
            response.message || "Live session notes saved successfully",
          );
          getSettingData();
          getSettingHistory();
        }
      })
      .catch((error) => {
        console.error("Error saving live session notes:", error);
        toast.dismiss();
        toast.error("Failed to save live session notes");
      })
      .finally(() => {
        setLiveSessionNotesLoading(false);
      });
  };

  const handleSaveWinningSlipNote = async () => {
    setWinningSlipNoteLoading(true);
    const payload = {
      note: "winning_slip",
      live_session_notes: winningSlipNote,
    };

    settingApi
      .UpdateLiveSessionNotes(payload)
      .then((response) => {
        if (response.isSuccess) {
          toast.success(
            response.message || "Winning slip note saved successfully",
          );
          getSettingData();
          getSettingHistory();
        }
      })
      .catch((error) => {
        console.error("Error saving winning slip note:", error);
        toast.dismiss();
        toast.error("Failed to save winning slip note");
      })
      .finally(() => {
        setWinningSlipNoteLoading(false);
      });
  };

  const getSettingHistory = async () => {
    setLoading(true);
    settingApi
      .getSettingHistoryData(
        page,
        limit,
        filter,
        referenceTypeFilter || undefined,
      )
      .then((response) => {
        if (response.isSuccess) {
          setData(response.data || []);
          setPagination(response.pagination || {});
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error("Error get settings:", error);
        toast.dismiss();
        toast.error("Error get settings");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const getSettingData = async () => {
    settingApi
      .getSettingData()
      .then((response) => {
        if (response.isSuccess) {
          const data = response.data;
          if (data) {
            setMainTitle(data?.main_title || "");
            setSubTitle(data?.sub_title || "");
            setYantra(data?.yantra_amount);
            setWinning(data?.winning_amount);
            setDifference(data?.difference);
            setGames({
              "3min": data?.game_3min,
              "5min": data?.game_5min,
            });
            setLoginNotes(data?.login_notes || "");
            setHomeNotes(data?.home_notes || "");
            setLiveSessionNote1(data?.live_session_note1 || "");
            setLiveSessionNote2(data?.live_session_note2 || "");
            setWinningSlipNote(data?.winning_slip_note || "");
          }
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        console.error("Error get settings:", error);
        toast.dismiss();
        toast.error("Error get settings");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getSettingData();
  }, []);

  useEffect(() => {
    getSettingHistory();
  }, [page, limit, filter, referenceTypeFilter]);

  return (
    <>
      <div className="settings-wrapper">
        <div className={`settings-card ${loading ? "blur" : ""}`}>          
          <div className="input-grid">
            <div className="input-box">
              <label>Main Title</label>
              <input
                type="text"
                value={mainTitle}
                onChange={(e) => setMainTitle(e.target.value)}
              />  
            </div>

            <div className="input-box">
              <label>Sub Title</label>
              <input
                type="text"
                value={subTitle}
                onChange={(e) => setSubTitle(e.target.value)}
              />
            </div>
          </div>
          <hr className="m-0 mt-1" />
          <div className="input-grid">
            <div className="input-box">
              <label>Yantra Amount</label>
              <input
                type="number"
                value={yantra}
                onChange={(e) => setYantra(+e.target.value)}
              />
            </div>

            <div className="input-box">
              <label>Winning Amount</label>
              <input
                type="number"
                value={winning}
                onChange={(e) => setWinning(+e.target.value)}
              />
            </div>
          </div>
          <div className="input-grid">
            <div className="input-box">
              <label>Difference Winning Amount</label>
              <input
                type="number"
                value={difference}
                onChange={(e) => setDifference(+e.target.value)}
              />
            </div>
          </div>
          <div className="game-control">
            <h5 className="mt-3">Session Control</h5>
            <hr className="m-0" />

            {Object.keys(games).map((key) => (
              <div key={key} className="game-row">
                <div>
                  <strong>{key} Session</strong>
                  <small className={games[key] ? "live" : "stopped"}>
                    {games[key] ? "LIVE" : "STOPPED"}
                  </small>
                </div>

                <button
                  className={games[key] ? "btn-stop" : "btn-start"}
                  onClick={() => toggleGame(key)}
                >
                  {games[key] ? "STOP" : "START"}
                </button>
              </div>
            ))}
          </div>

          <button className="save-btn" onClick={handleSave} disabled={loading}>
            {loading ? "Saving..." : "Save Changes"}
          </button>

          <hr />
          <div>
            <div>
              <label className="setting-input-label">Login Notes</label>
              <div className="setting-input-box">
                <textarea
                  placeholder="Enter login notes"
                  value={loginNotes}
                  onChange={(e) => setLoginNotes(e.target.value)}
                  rows={5}
                  className="setting-input-textarea"
                >
                  {loginNotes}
                </textarea>
                <button
                  className="setting-save-notes-btn"
                  onClick={handleSaveLoginNotes}
                  disabled={loginNotesLoading}
                >
                  {loginNotesLoading ? "Saving..." : "Save Login Notes"}
                </button>
              </div>
            </div>
            <div>
              <label className="setting-input-label">Home Notes</label>
              <div className="setting-input-box">
                <textarea
                  placeholder="Enter home notes"
                  value={homeNotes}
                  onChange={(e) => setHomeNotes(e.target.value)}
                  rows={5}
                  className="setting-input-textarea"
                >
                  {homeNotes}
                </textarea>
                <button
                  className="setting-save-notes-btn"
                  onClick={handleSaveHomeNotes}
                  disabled={homeNotesLoading}
                >
                  {homeNotesLoading ? "Saving..." : "Save Home Notes"}
                </button>
              </div>
            </div>
            <div>
              <label className="setting-input-label">Live Session Note1</label>
              <div className="setting-input-box">
                <textarea
                  placeholder="Enter live session note1"
                  value={liveSessionNote1}
                  onChange={(e) => setLiveSessionNote1(e.target.value)}
                  rows={3}
                  className="setting-input-textarea"
                >
                  {liveSessionNote1}
                </textarea>
                <button
                  className="setting-save-notes-btn"
                  onClick={() => handleSaveLiveSessionNotes("note1")}
                  disabled={liveSessionNotesLoading}
                >
                  {liveSessionNotesLoading
                    ? "Saving..."
                    : "Save Live Session Note1"}
                </button>
              </div>
            </div>
            <div>
              <label className="setting-input-label">Live Session Note2</label>
              <div className="setting-input-box">
                <textarea
                  placeholder="Enter live session note2"
                  value={liveSessionNote2}
                  onChange={(e) => setLiveSessionNote2(e.target.value)}
                  rows={3}
                  className="setting-input-textarea"
                >
                  {liveSessionNote2}
                </textarea>
                <button
                  className="setting-save-notes-btn"
                  onClick={() => handleSaveLiveSessionNotes("note2")}
                  disabled={liveSessionNotesLoading}
                >
                  {liveSessionNotesLoading
                    ? "Saving..."
                    : "Save Live Session Note2"}
                </button>
              </div>
            </div>
            <div>
              <label className="setting-input-label">Winning Slip Note</label>
              <div className="setting-input-box">
                <textarea
                  placeholder="Enter winning slip note"
                  value={winningSlipNote}
                  onChange={(e) => setWinningSlipNote(e.target.value)}
                  rows={3}
                  className="setting-input-textarea"
                >
                  {winningSlipNote}
                </textarea>
                <button
                  className="setting-save-notes-btn"
                  onClick={() => handleSaveWinningSlipNote()}
                  disabled={winningSlipNoteLoading}
                >
                  {winningSlipNoteLoading
                    ? "Saving..."
                    : "Save Winning Slip Note"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="history-wrapper">
        <div className="d-flex align-items-center justify-content-between">
          <h5>Settings History</h5>

          {/* FILTERS */}
          <div className="filter-bar history-filters">
            <select
              value={referenceTypeFilter}
              onChange={(e) => {
                setPage(1);
                setReferenceTypeFilter(e.target.value);
              }}
            >
              <option value="GLOBAL">Global (session settings)</option>
              <option value="NOTES">Note (all notes history)</option>
            </select>
            <select
              value={filter}
              onChange={(e) => {
                setPage(1);
                setFilter(e.target.value);
              }}
            >
              <option value={3}>Last 3 Days</option>
              <option value={7}>Last 7 Days</option>
              <option value={30}>Last 30 Days</option>
              <option value="all">All time</option>
            </select>
          </div>
        </div>

        <div>
          {loading ? (
            <Loader message="Loading history..." />
          ) : (
            <>
              {/* TABLE */}
              <div className="table-responsive">
                <table className="settings-history-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      {referenceTypeFilter === "GLOBAL" ? (
                        <>
                          <th className="text-nowrap">Yantra</th>
                          <th className="text-nowrap">Winning</th>
                          <th className="text-nowrap">Difference</th>
                          <th className="text-nowrap">3 Min</th>
                          <th className="text-nowrap">5 Min</th>
                        </>
                      ) : referenceTypeFilter === "NOTES" ? (
                        <>
                          <th className="text-nowrap">Type</th>
                          <th>Details</th>
                        </>
                      ) : (
                        <>
                          <th className="text-nowrap">Type</th>
                          <th className="text-nowrap">Yantra</th>
                          <th className="text-nowrap">Winning</th>
                          <th className="text-nowrap">Difference</th>
                          <th className="text-nowrap">3 Min</th>
                          <th className="text-nowrap">5 Min</th>
                          <th>Details</th>
                        </>
                      )}
                      <th className="text-nowrap">Date</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan={10}>
                          <div className="d-flex align-items-center justify-content-center mb-5">
                            <NoData
                              message="No Settings History Found"
                              subText="No changes have been made yet. Update and save settings to view history."
                            />
                          </div>
                        </td>
                      </tr>
                    ) : (
                      <>
                        {data.map((row, i) => {
                          const refTypeRaw = row.reference_type
                            ? String(row.reference_type).toUpperCase()
                            : "GLOBAL";
                          const noteTypes = [
                            "LOGIN_NOTES",
                            "HOME_NOTES",
                            "LIVE_SESSION_NOTE1",
                            "LIVE_SESSION_NOTE2",
                            "WINNING_SLIP_NOTE",
                          ];
                          const isNote = noteTypes.includes(refTypeRaw);
                          const refType = isNote ? refTypeRaw : "GLOBAL";

                          const dateStr = row.created_at
                            ? new Date(row.created_at).toLocaleString()
                            : "—";

                          if (isNote) {
                            let noteText = "—";
                            try {
                              const parsed =
                                typeof row.settings_data === "string"
                                  ? JSON.parse(row.settings_data)
                                  : row.settings_data;
                              // Bind new_notes first (used by all note types), then type-specific keys for backward compatibility
                              if (parsed?.new_notes != null) {
                                noteText = String(parsed.new_notes);
                              } else if (
                                refType === "LOGIN_NOTES" &&
                                parsed?.new_notes != null
                              ) {
                                noteText = String(parsed.new_notes);
                              } else if (
                                refType === "HOME_NOTES" &&
                                parsed?.new_notes != null
                              ) {
                                noteText = String(parsed.new_notes);
                              } else if (parsed) {
                                noteText = String(parsed.new_notes);
                              }
                            } catch (_) {
                              noteText =
                                typeof row.settings_data === "string"
                                  ? row.settings_data
                                  : "—";
                            }
                            const excerpt =
                              noteText.length > 80
                                ? noteText.slice(0, 80) + "…"
                                : noteText;
                            const noteLabels = {
                              LOGIN_NOTES: "Login notes",
                              HOME_NOTES: "Home notes",
                              LIVE_SESSION_NOTE1: "Live session note 1",
                              LIVE_SESSION_NOTE2: "Live session note 2",
                              WINNING_SLIP_NOTE: "Winning slip note",
                            };
                            const noteLabel = noteLabels[refType] || refType;
                            const noteBadgeClass =
                              refType === "HOME_NOTES"
                                ? "home-notes"
                                : refType === "LOGIN_NOTES"
                                  ? "login-notes"
                                  : refType === "WINNING_SLIP_NOTE"
                                    ? "winning-slip-notes"
                                    : "live-session-notes";
                            return (
                              <tr key={row.id}>
                                <td>{(page - 1) * 10 + i + 1}</td>
                                <td>
                                  <span
                                    className={`history-type-badge ${noteBadgeClass}`}
                                  >
                                    {noteLabel}
                                  </span>
                                </td>
                                <td
                                  className="history-details-cell"
                                  title={noteText}
                                >
                                  {excerpt}
                                </td>
                                <td className="text-nowrap">{dateStr}</td>
                              </tr>
                            );
                          }

                          let s = {};
                          try {
                            s =
                              typeof row.settings_data === "string"
                                ? JSON.parse(row.settings_data)
                                : row.settings_data || {};
                          } catch (_) {}

                          return (
                            <tr key={row.id}>
                              <td>{(page - 1) * 10 + i + 1}</td>
                              <td>
                                {s.yantra_amount != null
                                  ? s.yantra_amount
                                  : "—"}
                              </td>
                              <td>
                                {s.winning_amount != null
                                  ? s.winning_amount
                                  : "—"}
                              </td>
                              <td>
                                {s.difference != null ? s.difference : "—"}
                              </td>
                              {s.game_3min ? (
                                <td className="game-on_text">ON</td>
                              ) : (
                                <td className="game-off_text">OFF</td>
                              )}
                              {s.game_5min ? (
                                <td className="game-on_text">ON</td>
                              ) : (
                                <td className="game-off_text">OFF</td>
                              )}
                              <td className="text-nowrap">{dateStr}</td>
                            </tr>
                          );
                        })}
                      </>
                    )}
                  </tbody>
                </table>
              </div>

              {/* PAGINATION */}
              {pagination && pagination.totalPages > 1 && (
                <div className="modern-pagination">
                  {/* Limit Selector */}
                  <div className="mp-limit">
                    <span>Show</span>
                    <select
                      value={limit}
                      onChange={(e) => setLimit(e.target.value)}
                    >
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>

                  {/* Navigation */}
                  <div className="mp-controls">
                    <button
                      disabled={page === 1}
                      onClick={() => setPage(page - 1)}
                    >
                      Prev
                    </button>

                    <div className="mp-info">
                      Page <strong>{pagination.page}</strong> of{" "}
                      <strong>{pagination.totalPages}</strong>
                    </div>

                    <button
                      disabled={page === pagination.totalPages}
                      onClick={() => setPage(page + 1)}
                    >
                      Next
                    </button>
                  </div>

                  {/* Jump to Page */}
                  <div className="mp-jump">
                    <select
                      value={page}
                      onChange={(e) => setPage(e.target.value)}
                    >
                      {Array.from({ length: pagination.totalPages }, (_, i) => (
                        <option key={i + 1} value={i + 1}>
                          Page {i + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </>
  );
}
